export default "__VITE_ASSET__aaabd9ba__$_?component__"